import type { BudgetGroupFragment } from "@src/__generated__/graphql";
import { budgetovacApi } from "@src/services/budgetovac";
import { BooleanState } from "@src/utils/mobx/states/BooleanState";
import { FieldState } from "formstate";
import { compact, uniqueId } from "lodash";
import { action, computed, makeObservable, observable } from "mobx";
import { BudgetModel } from "./budget";

export class BudgetGroupModel {
  readonly dataComponentName = `budget-group-${uniqueId()}`;
  name: FieldState<string>;
  number: BudgetGroupFragment["budget_number"];
  @observable budgets: BudgetModel[] = [];
  @observable.ref selectedIds: string[] = [];

  isNameEditLoading = new BooleanState(false);

  constructor(budgetGroup: BudgetGroupFragment) {
    makeObservable(this);
    this.name = new FieldState(budgetGroup.budget_name ?? "");
    this.number = budgetGroup.budget_number;
    this.budgets = budgetGroup.budgets
      ? compact(budgetGroup.budgets).map((budget) => new BudgetModel(budget))
      : [];
  }

  @computed get isAssigning() {
    return this.budgets.some((budget) => budget.isAssigning.value);
  }

  @action.bound async handleUpdateGroupName(
    newName: string,
    projectId: number,
    budgetNumber: number,
  ) {
    this.isNameEditLoading.on();

    try {
      await budgetovacApi.updateBudgetName(newName, projectId, budgetNumber);
      this.name = new FieldState(newName);
    } catch (e) {
      console.error(e);
    }

    this.isNameEditLoading.off();
  }

  @action.bound async handleBudgetDelete(id: string) {
    const index = this.budgets.findIndex((budget) => budget.id === id);
    if (index === -1) return;
    await this.budgets[index].handleDelete();
    this.budgets.splice(index, 1);
  }

  @action.bound handleSelectIds(ids: string[]) {
    this.selectedIds = ids;
  }
}
